import podAxios from './podAxios'
import { toDomainHttpClient } from './toDomainHttpClient'

// POD 요청은 트래킹하지 않는다.
export const domainPodHttpClient = toDomainHttpClient(podAxios, { forwardMeta: false })
